/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo, useState } from "react";
import Validation from "../../../../utils/validation";
import AccountName from "../../../_utils/AccountCreationComponents/AccountName";
import ContactDetails from "../../../_utils/AccountCreationComponents/ContactDetails";
import LoginDetails from "./LoginDetails";
import UserGrade from "./UserGrade";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";

const UserDetailsInput = ({
  userPayload,
  selectedValue,
  setUserPayload,
  setSelectedValue,
  verifyPAN,
  accountNameValidation,
  setAccountNameValidation,
  contactNumberValidation,
  setContactNumberValidation,
  emailValidation,
  setEmailValidation,
  aliasValidation,
  setAliasValidation,
  passwordValidation,
  setPasswordValidation,
  userIdValidation,
  setUserIdValidation,
  gradeOption,
}) => {
  const [customErrors, setCustomErrors] = useState({});

  const modifyValue = (type, value) => {
    if (type === "gstin") {
      return value?.toUpperCase();
    }
    return value.trim();
  };

  const allowedValue = (name, value) => {
    if (name === "account_name") return /^[a-zA-Z0-9 ]*$/.test(value);
    if (name === "contact_no") return Validation.allowedContactNum(value);
    if (name === "email_id") return Validation.allowedEmail(value);
    return true;
  };

  const validateAndRecordError = (name, value) => {
    let errors = { ...customErrors };
    if (name === "email_id")
      errors = Validation.validateEmail(name, value, errors);
    if (name === "contact_no")
      errors = Validation.validateContactNum(name, value, errors);

    if (name === "account_name") {
      if (!Validation.alphanumericRegex.test(value)) {
        errors[name] = "Only alphabets, numbers and spaces are allowed";
      } else {
        delete errors[name];
      }
    }

    setCustomErrors(errors);
  };
  const handleChange = (e) => {
    let { name, value } = e.target;
    if (name !== "account_name") {
      value = modifyValue(name, value?.replace(/\s/g, ""));
    } else {
      value = value.replace(/\s+/g, " ");
    }

    if (userPayload) {
      if (!allowedValue(name, value)) {
        return;
      }
      validateAndRecordError(name, value);
      const newObj = { ...userPayload, [name]: value };
      setUserPayload(newObj);
      if (
        userPayload?.contact_no &&
        (userPayload?.contact_no?.length === 0 ||
          userPayload?.contact_no?.length < 10)
      ) {
        setContactNumberValidation(false);
      }
      if (userPayload?.email_id && userPayload?.email_id?.length === 0) {
        setEmailValidation(false);
      }
      if (name === "account_name") {
        if (value.trim().length > 0) {
          if (value === verifyPAN?.pan_details?.full_name) {
            setSelectedValue("legalname");
          } else {
            setSelectedValue("customname");
          }
          setAccountNameValidation(true);
        } else {
          setAccountNameValidation(false);
        }
      }
    }
  };
  const handleRadioBtn = (event) => {
    setSelectedValue(event.target.value);
    if (event.target.value === "legalname") {
      handleUpdateLegalName();
    }
  };

  const handleDivBtn = (value) => {
    setSelectedValue(value);
    if (value === "legalname") {
      handleUpdateLegalName();
    }
  };
  const handleUpdateLegalName = () => {
    const beneficiaryData = verifyPAN?.pan_details?.full_name;
    setUserPayload((prevPayload) => ({
      ...prevPayload,
      account_name: beneficiaryData,
    }));
    setAccountNameValidation(true);
  };

  useMemo(() => {
    if (customErrors["contact_no"]) {
      setContactNumberValidation(false);
    }
    if (!customErrors["contact_no"] && userPayload?.contact_no?.length === 10) {
      setContactNumberValidation(true);
    }
    if (customErrors["email_id"]) {
      setEmailValidation(false);
    }
    if (
      !customErrors["email_id"] &&
      userPayload?.email_id?.length > GlobalConfiguration.lengthCheckZero &&
      Validation.emailRegex.test(userPayload?.email_id)
    ) {
      setEmailValidation(true);
    }
  }, [contactNumberValidation, emailValidation, customErrors, userPayload]);

  return (
    <div className="flex flex-col Qsmd:flex-row px-padding-md lg:px-padding-base py-padding-md Qsmd:py-padding-base Qsmd:gap-gap-xl gap-gap-md">
      <div className="flex flex-col Qsmd:flex-row w-width-full gap-gap-md Qsmd:gap-gap-xl">
        <div className="flex flex-col relative w-width-full Qsmd:w-width-md lg:max-w-[var(--create-box-width)]">
          <AccountName
            handleChange={handleChange}
            accountNameValidation={accountNameValidation}
            accountName={userPayload?.account_name}
            selectedValue={selectedValue}
            handleDivBtn={handleDivBtn}
            handleRadioBtn={handleRadioBtn}
            selectedRadioValue={selectedValue}
            legalName={userPayload?.legalName}
            placeHolder={"User name"}
          />
          <UserGrade
            userPayload={userPayload}
            setUserPayload={setUserPayload}
            gradeOption={gradeOption}
          />
        </div>
        <div className="flex flex-col relative w-width-full Qsmd:w-width-md lg:max-w-[var(--create-box-width)]">
          <ContactDetails
            handleChange={handleChange}
            contactNumberValidation={contactNumberValidation}
            emailValidation={emailValidation}
            contactNumber={userPayload?.contact_no}
            emailId={userPayload?.email_id}
            selectedValue={selectedValue}
          />
          <LoginDetails
            userPayload={userPayload}
            setUserPayload={setUserPayload}
            handleChange={handleChange}
          />
        </div>
      </div>
    </div>
  );
};

export default UserDetailsInput;
